import React from 'react';
import {
    Page
   ,Content
   ,PopUp } from '@beisen/chaos-ui';

export default class CommonPanel extends React.Component {
     constructor(...args) {
         super(...args);
     }

     render() {
         return (
            <PopUp {...this.props.popOptions} maskClosable={this.props.maskClosable}>
                <Page {...this.props.pageOption}>
                    {this.props.nav}
                    <Content {...this.props.contentOption} >
                        {this.props.content}
                    </Content>
                    {this.props.footer ? this.props.footer : null}
                </Page>
            </PopUp>);
     }
}



// WEBPACK FOOTER //
// ./src/components/Common/CommonPanel.js